import { $axios, useAuthTokenError, objectToUrlParams } from '../utils'
import '../typedefs'
import { validateCreatePrayerRequest, validateMarkAllPrayerRequestsAsRead } from '../validators/prayer-requests.validators'

/**
 * Gets all prayer requests for an authenticated user.
 * @param {String} authToken Auth token
 * @returns {import('axios').AxiosResponse<PrayerRequest[]>}
 */
export function getPrayerRequests (authToken, queryObject) {
  useAuthTokenError(authToken)
  const queryString = objectToUrlParams(queryObject)
  return $axios(`/prayerRequests?${queryString}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Gets unread prayer requestscount
 * @param {String} authToken Auth token
 * @returns {import('axios').AxiosResponse<PrayerRequest[]>}
 */
export function getUnreadPrayerRequests (authToken) {
  useAuthTokenError(authToken)
  return $axios(`/reports/unread`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Gets a single prayer request by prayer request Id
 * @param {String} authToken Auth token
 * @param {String} id prayer request id
 * @returns {import('axios').AxiosResponse<{ message: String, data: PrayerRequest }>}
 */
export function getPrayerRequestById (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/prayerRequests/${id}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Creates a new prayer request for an authenticated user.
 * @param {String} authToken Auth token
 * @param {PrayerRequest} payload New prayer request data
 * @returns {import('axios').AxiosResponse<{ message: String, data: PrayerRequest }>}
 */
export function createPrayerRequest (authToken, payload) {
  // useAuthTokenError(authToken)
  validateCreatePrayerRequest(payload)

  return $axios('/prayerRequests', {
    method: 'POST',
    headers: {
      Authorization: authToken,
      'x-access-token': authToken
    },
    data: payload
  })
}

/**
 * Updates a prayer request
 * @param {String} authToken Auth token
 * @param {String} id prayer request id
 * @param {PrayerRequest} payload Category data
 * @returns {import('axios').AxiosResponse<{ message: String, data: PrayerRequest }>}
 */
export function updatePrayerRequest (authToken, id, payload) {
  useAuthTokenError(authToken)
  // Same validation for creation is used for updating a prayer request
  validateCreatePrayerRequest(payload)

  return $axios(`/prayerRequests/${id}`, {
    method: 'PUT',
    headers: {
      'x-access-token': authToken
    },
    data: payload
  })
}

export function markAllAsRead (authToken, payload) {
  useAuthTokenError(authToken)

  validateMarkAllPrayerRequestsAsRead(payload)

  return $axios('/prayerRequests/readStatus', {
    method: 'PUT',
    headers: {
      'x-access-token': authToken
    },
    data: {
      ids: payload
    }
  })
}

/**
 * Deletes a prayer request
 * @param {String} authToken Auth token
 * @param {String} id Category id
 * @returns {import('axios').AxiosResponse<{ message: String }>}
 */
export function deletePrayerRequest (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/prayerRequests/${id}`, {
    method: 'DELETE',
    headers: {
      'x-access-token': authToken
    }
  })
}
